import { AtomField } from 'atoms/form-atoms';
import { TextArea, TextAreaProps, Layer } from '@carbon/react';
import classNames from 'classnames';
import { useAtomValue, useSetAtom } from 'jotai';
import style from './text-area-field.module.scss';

interface Props extends Omit<TextAreaProps, 'light'> {
  fieldAtom: AtomField<string | null> | AtomField<string>;
  light?: boolean;
}

export function TextAreaField({ fieldAtom, light, ...rest }: Props) {
  const setField = useSetAtom(fieldAtom);
  const field = useAtomValue(fieldAtom);

  const textArea = (
    <TextArea
      value={field.value || ''}
      onChange={({ target: { value } }) => setField(value)}
      invalid={!field.isValid && field.isDirty}
      invalidText={!field.isValid && field.isDirty ? field.error : ''}
      {...rest}
    />
  );

  return (
    <div className={classNames({ [style.light]: light })}>
      {light ? <Layer>{textArea}</Layer> : textArea}
    </div>
  );
}
